// @flow
import { Provider as RollbarProvider, ErrorBoundary as RollbarErrorBoundary } from "@rollbar/react";
import { BrowserRouter } from "react-router-dom";

import "buba-components/src/polyfills";

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { Preloader, FlashMessageContainer } from "buba-components";
import { rollbarConfig } from "buba-components/src/utils/environment";
import {
  FlagsProvider,
  flagsStatus,
  INQUIRY_FORM_LINK,
  PASSWORD_RESET
} from "buba-components/src/utils/featureFlags";

import App from "./views/App";

import { store, persistor } from "./store";

import "normalize.css";
import "./styles/index.scss";
import "buba-components/src/styles/icons.scss";

(async () => {
  const domNode = document.getElementById("root");
  const root = ReactDOM.createRoot(domNode);
  const flags = await flagsStatus([INQUIRY_FORM_LINK, PASSWORD_RESET]);

  if (root) {
    root.render(
      <RollbarProvider config={rollbarConfig}>
        <RollbarErrorBoundary>
          <Provider store={store}>
            <PersistGate loading={<Preloader />} persistor={persistor}>
              <FlashMessageContainer visibilityTimeout={8000}>
                <FlagsProvider flags={flags}>
                  <BrowserRouter basename="/bankportal">
                    <App />
                  </BrowserRouter>
                </FlagsProvider>
              </FlashMessageContainer>
            </PersistGate>
          </Provider>
        </RollbarErrorBoundary>
      </RollbarProvider>
    );
  }
})();
